export default {
  //SYSTEM ACTIONS
  SHOW_MODAL: "SHOW_MODAL",
  UNSHOW_MODAL: "UNSHOW_MODAL",
  SHOW_MENU: "SHOW_MENU",
  UNSHOW_MENU: "UNSHOW_MENU",

  //USER ACTIONS
  EXAMPLE_COLLECTION: "EXAMPLE_COLLECTION",
  CREATE_COLLECTION: "CREATE_COLLECTION",
  SELECT_COLLECTION: "SELECT_COLLECTION",
  DESELECT_COLLECTION: "DESELECT_COLLECTION",
  COPY_COLLECTION: "COPY_COLLECTION",
  RENAME_COLLECTION: "RENAME_COLLECTION",
  DELETE_COLLECTION: "DELETE_COLLECTION",

  CREATE_TABLE: "CREATE_TABLE",
  UPDATE_TABLE: "UPDATE_TABLE",
  SWAP_TABLE: "SWAP_TABLE",
  DELETE_TABLE: "DELETE_TABLE",

  CREATE_LECTURE: "CREATE_LECTURE",
  UPDATE_LECTURE: "UPDATE_LECTURE",
  DELETE_LECTURE: "DELETE_LECTURE",

  CREATE_DAY: "CREATE_DAY",
  UPDATE_DAY: "UPDATE_DAY",
  SWAP_DAY: "SWAP_DAY",
  DELETE_DAY: "DELETE_DAY",

  CREATE_TIME: "CREATE_TIME",
  UPDATE_TIME: "UPDATE_TIME",
  SWAP_TIME: "SWAP_TIME",
  DELETE_TIME: "DELETE_TIME",

  CREATE_PLACE: "CREATE_PLACE",
  UPDATE_PLACE: "UPDATE_PLACE",
  SWAP_PLACE: "SWAP_PLACE",
  DELETE_PLACE: "DELETE_PLACE",

  CREATE_BATCH: "CREATE_BATCH",
  UPDATE_BATCH: "UPDATE_BATCH",
  SWAP_BATCH: "SWAP_BATCH",
  DELETE_BATCH: "DELETE_BATCH",

  CREATE_SUBJECT: "CREATE_SUBJECT",
  UPDATE_SUBJECT: "UPDATE_SUBJECT",
  SWAP_SUBJECT: "SWAP_SUBJECT",
  DELETE_SUBJECT: "DELETE_SUBJECT",

  CREATE_TEACHER: "CREATE_TEACHER",
  UPDATE_TEACHER: "UPDATE_TEACHER",
  SWAP_TEACHER: "SWAP_TEACHER",
  DELETE_TEACHER: "DELETE_TEACHER"
};
